import React, { useEffect, useLayoutEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { connect } from "react-redux";
import { START_GET_LOGIN_USER } from "Actions/UserAction";
import API from "Api";

const useStyle = makeStyles((theme) => ({
  repeatsmartLink: {
    textAlign: "right",
    marginBottom: "25px !important",
    marginTop: "10px !important",
  },
  rsDividerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "8px !important",
    "&>div": {
      margin: "0 6px !important",
      height: "36px",
      width: "36px",
      borderRadius: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: `${theme.palette.white.main}`,
      boxShadow: "0px 4px 4px rgba(90, 104, 114, 0.15)",
    },
  },
  rsDividerLine: {
    width: "100px !important",
    height: "1px !important",
    background: "#5A6872CC",
  },
  rsButton: {
    marginTop: "30px !important",
    "&>button": {
      display: "flex",
      margin: "auto",
      padding: "8px 50px !important",
    },
  },
  rsPassword: {
    left: "15px !important",
    "&>svg": {
      height: "23px",
      width: "23px",
    },
  },
}));

const PharmasmartLogin = (props) => {
  const params = useParams();
  const { getUserDetails, loginUserDetail } = props;
  const navigate = useNavigate();

  /** Login Success UseEffect */
  useEffect(() => {
    API.setAccessTokenInLocalStorage(params?.token);
    // detail
    getUserDetails();
  }, []);

  // useLayoutEffect(() => {
  //   function receiveMessage(event) {
  //     if (event?.data?.token) {
  //       const token = event?.data?.token;
  //       API.setAccessTokenInLocalStorage(token);
  //       getUserDetails();
  //     } else {
  //       navigate("login");
  //     }
  //   }
  //   window.addEventListener("message", receiveMessage);
  //   return () => {
  //     window.removeEventListener("message", receiveMessage);
  //   };
  // }, []);

  useEffect(() => {
    if (loginUserDetail?.data?.success === true) {
      navigate("/home");
    } else {
      navigate("login");
    }
  }, [loginUserDetail]);

  return <>LOADER</>;
};

const mapStateToProps = (state) => ({
  loginUserDetail: state.user.loginUserDetail,
});
const mapDispatchToProps = (dispatch) => ({
  getUserDetails: () => dispatch({ type: START_GET_LOGIN_USER }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PharmasmartLogin);
